// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".countdown[data-v-6f670dbe]{width:100%;padding:4px 10px;font-size:12px;font-weight:400}.countdown[data-v-6f670dbe],.countdown .box[data-v-6f670dbe]{box-sizing:border-box;display:flex;align-items:center}.countdown .box[data-v-6f670dbe]{justify-content:center;width:30px;height:18px;margin:0 2px;border:1px solid #eeca82;border-radius:4px}", ""]);
// Exports
module.exports = exports;
